import React, { FC, useCallback } from 'react';
import { deleteUnit } from 'actions/scholars';
import { connect, useDispatch } from 'react-redux';
import { setActiveScholar } from 'actions/users';
import _ from 'lodash';
import { IRootState } from 'store';
import { PopupData } from 'types';
import ScholarsListItem from './scholarsListItem';

import styles from './index.module.scss';

const mstp = (state: IRootState) => ({
  units: state.scholars.units,
  userType: state.users.userData?.type,
  activeScholarId: state.users.userData?.activeScholarId,
});

type Props = ReturnType<typeof mstp> & {
  popupData: PopupData;
  isActiveSubscription: boolean;
};

const ScholarsList: FC<Props> = ({
  units,
  activeScholarId,
  userType,
  popupData,
  isActiveSubscription,
}) => {
  const dispatch = useDispatch();

  const deleteScholar = (id: number) => {
    dispatch(deleteUnit(id));
  };

  const makeKidActive = useCallback(
    (id: number) => {
      dispatch(setActiveScholar(id));
    },
    [dispatch]
  );

  return (
    <div className={styles.scholarsList}>
      {!_.isEmpty(units) &&
        _.map(units, (kid) => (
          <ScholarsListItem
            deleteScholar={deleteScholar}
            isActiveSubscription={isActiveSubscription}
            data={kid}
            activeScholarId={activeScholarId || 0}
            makeKidActive={makeKidActive}
            userType={userType || ''}
            key={kid.id}
            popupData={popupData}
          />
        ))}
    </div>
  );
};

export default connect(mstp)(ScholarsList);
